export const GET_PRICE_PLAN_TYPE = 'GET_PRICE_PLAN_TYPE';
